import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { CreateNoteForm } from '@components/Notes/CreateForm';
import { PageTitle } from '@components/PageTitle';
import { queryKeys } from '@constants/queryKeys.constant';
import { ENoteOwnerType } from '@enums/note.enum';
import { updateServiceRequestCounts } from '@helpers/queryCache/updateTabCounts.helper';

export const Route = createFileRoute(
  '/_layout/(private)/service-requests/$id/notes/create',
)({
  component: ServiceRequestNoteCreate,
});

function ServiceRequestNoteCreate() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <>
      <PageTitle
        hasBackButton
        params={{ id }}
        title="Create note"
        to="/service-requests/$id"
      />
      <CreateNoteForm
        notePayload={{
          ownerType: ENoteOwnerType.ServiceRequest,
          serviceRequestId: id,
        }}
        onCancel={() =>
          navigate({ params: { id }, to: '/service-requests/$id' })
        }
        onCreate={() =>
          updateServiceRequestCounts({
            delta: 1,
            field: 'notes',
            queryClient,
            serviceRequestId: id,
          })
        }
        onSuccess={() =>
          navigate({
            params: { id },
            replace: true,
            to: '/service-requests/$id',
          })
        }
        queryKeyToInvalidate={queryKeys.serviceRequests.notes(id)}
      />
    </>
  );
}
